<template>
  <li role="presentation">
    <router-link v-if="to"
      v-bind:to="to"
      class="dropdown-item"
      role="menuitem"
      v-on:click="onClick"><slot></slot></router-link>
    <a v-else
      href="#"
      class="dropdown-item"
      role="menuitem"
      v-on:click.prevent="onClick"><slot></slot></a>
  </li>
</template>

<script>
// Élément de <bs-dropdown> : lien du routeur (to) ou simple action (click), puis fermeture du menu.
export default {
  name: 'BsDropdownItem',
  inject: {
    bsDropdown: { default: null },
  },
  props: {
    to: {
      type: [String, Object],
      required: false,
    },
  },
  emits: ['click'],
  methods: {
    onClick(event) {
      this.$emit('click', event);
      if (this.bsDropdown) {
        // après la navigation du lien, comme bootstrap-vue
        requestAnimationFrame(() => this.bsDropdown.hide(true));
      }
    },
  },
};
</script>
